import {AxiosResponse} from "axios";
import Api from "./api";

export default class CategoriesService {
    static async create(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/categories/create', fields);
    }

    static async query(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/categories/query', fields);
    }

    static async update(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/categories/update', fields);
    }
}